import React from 'react';
import { FlatList, TouchableOpacity, View } from 'react-native'

import api from "../../../../../utils/api"
import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { Icon as SvgIcon } from '../../../../../components/Icon';
import ChevronChico from '../../../../../components/ChevronChico';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';

import dayjs from 'dayjs'
import Header from '../../../../../navigation/Header';
import { useNavigation } from '@react-navigation/native';
import useOpenDetailParam from '../../../../../hooks/useOpenDetailParam';


function PaymentEvidenceCard({ paymentEvidence, communityId, selected }) {
  const navigation = useNavigation()

  const dateStr = dayjs(paymentEvidence.created_at).format('D/MM/YYYY')
  const owner = paymentEvidence.unit?.owners?.[0]?.name
  const thumb = paymentEvidence.images?.[0]?.thumbnails?.['250']?.url
  const amount = (paymentEvidence.amount ?? 0).toLocaleString()

  const goToValidatorPage = () => {
    navigation.navigate('Admin.Payments.EvidenceDetail', {
      communityId,
      payment_evidence_id: paymentEvidence.uuid,
    })
  }

  return (
    <TouchableOpacity
      style={tw.style(`bg-white rounded-2xl px-4 py-4 mb-3 mx-4 row items-center border border-gray-200`, selected && `bg-selected border-selected-border`)}
      onPress={goToValidatorPage}
    >
      {thumb ? (
        <Image source={{ uri: thumb }} style={tw`w-14 h-14 rounded-xl mr-3`} contentFit='cover' />
      ) : (
        <View style={tw`w-14 h-14 rounded-xl bg-gray-100 items-center justify-center mr-3`}>
          <SvgIcon name='image' size={22} color={tw.color('gray-400')} />
        </View>
      )}

      <View style={tw`flex-1`}>
        <View style={tw`row justify-between items-start`}>
          <Text style={tw`text-secondary font-600 text-base flex-1 mr-2`}>{paymentEvidence.unit?.name}</Text>
          <Text style={tw`text-secondary font-600 text-base`}>${amount}</Text>
        </View>

        {!!owner && <Text style={tw`text-gray-500 text-sm`}>{owner}</Text>}

        <Text style={tw`text-gray-400 text-xs mt-1`}>Comprobante #{paymentEvidence.id} · {dateStr}</Text>
      </View>

      <ChevronChico style={tw`ml-2`} />
    </TouchableOpacity>
  )
}


export default function PaymentEvidencesScreen({ route, navigation }) {
  const { communityId } = route.params
  const openEvidenceId = useOpenDetailParam(navigation, 'Admin.Payments.EvidenceDetail', 'payment_evidence_id', true)

  const { isInitialLoading, data: paymentEvidences } = useQuery({
    queryKey: ['community.payments.evidences', communityId],
    queryFn: () => api.get(`/communities/${communityId}/payments/evidences`).then(response => response.data),
  })

  return (
    <View style={tw`flex-1 bg-[#F3F2F3]`}>
      <Header
        showBackButton
        style={tw.style(`bg-secondary pb-4 rounded-b-0`)}
        backButtonColor='white'
      >
        <Text style={tw`text-lg font-600 text-white`}>Comprobantes de pago</Text>
      </Header>

      {isInitialLoading && (
        <Text style={tw`my-8 text-lg text-center text-gray-400`}>Cargando...</Text>
      )}

      {paymentEvidences?.length === 0 && (
        <Text style={tw`mt-25 text-lg text-center text-gray-400`}>Sin comprobantes por revisar</Text>
      )}

      <FlatList
        data={paymentEvidences}
        contentContainerStyle={tw`pt-4 pb-10`}
        extraData={openEvidenceId}
        renderItem={({ item }) => <PaymentEvidenceCard paymentEvidence={item} communityId={communityId} selected={item.uuid === openEvidenceId} />}
        keyExtractor={(item) => item.uuid}
      />
    </View>
  )
}
